
import { useState } from 'react';
import MobileBottomNav from '../../components/feature/MobileBottomNav';
import Navbar from '../../components/feature/Navbar';

export default function Notifications() {
  const [notifications, setNotifications] = useState([
    { id: '1', title: 'Transaction Successful', message: 'Your airtime recharge of ₦500 was successful', time: '2 hours ago', read: false, type: 'success', icon: 'ri-check-line' },
    { id: '2', title: 'New Offer Available', message: 'Get 20% bonus on your next recharge of ₦1000 or more', time: '5 hours ago', read: false, type: 'info', icon: 'ri-gift-line' },
    { id: '3', title: 'Payment Reminder', message: 'Your DSTV subscription expires in 3 days', time: '1 day ago', read: true, type: 'warning', icon: 'ri-alarm-warning-line' },
    { id: '4', title: 'Transaction Successful', message: 'Your data bundle purchase was successful', time: '2 days ago', read: true, type: 'success', icon: 'ri-check-line' },
    { id: '5', title: 'Wallet Funded', message: 'Your wallet has been credited with ₦10,000', time: '3 days ago', read: true, type: 'success', icon: 'ri-wallet-line' },
  ]);

  const markAsRead = (id) => {
    setNotifications(notifications.map(notif => 
      notif.id === id ? { ...notif, read: true } : notif
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({ ...notif, read: true })));
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-50 via-white to-cyan-50">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 pb-24 md:pb-8">
        <div className="flex justify-between items-center mb-4 md:mb-8">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1 md:mb-2">Notifications</h1>
            <p className="text-sm md:text-base text-gray-600">{unreadCount} unread notifications</p>
          </div>
          {unreadCount > 0 && (
            <button
              onClick={markAllAsRead}
              className="px-3 md:px-4 py-2 text-navy-600 hover:text-navy-700 font-medium text-xs md:text-sm cursor-pointer whitespace-nowrap"
            >
              Mark all as read
            </button>
          )}
        </div>

        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              onClick={() => markAsRead(notification.id)}
              className={`p-4 md:p-6 border-b border-gray-200 last:border-0 cursor-pointer transition-colors ${
                !notification.read ? 'bg-navy-50/50 hover:bg-navy-50' : 'hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start space-x-3 md:space-x-4">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                  notification.type === 'success' ? 'bg-green-100' :
                  notification.type === 'warning' ? 'bg-yellow-100' :
                  'bg-cyan-100'
                }`}>
                  <i className={`${notification.icon} text-xl md:text-2xl ${
                    notification.type === 'success' ? 'text-green-600' :
                    notification.type === 'warning' ? 'text-yellow-600' :
                    'text-cyan-600'
                  }`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-start mb-1">
                    <h3 className="font-semibold text-gray-900 text-sm md:text-base">{notification.title}</h3>
                    {!notification.read && (
                      <span className="w-2 h-2 bg-navy-600 rounded-full flex-shrink-0 ml-2 mt-2"></span>
                    )}
                  </div>
                  <p className="text-xs md:text-sm text-gray-600 mb-1 md:mb-2">{notification.message}</p>
                  <p className="text-xs text-gray-500">{notification.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {notifications.length === 0 && (
          <div className="bg-white rounded-xl shadow-sm p-8 md:p-12 text-center">
            <i className="ri-notification-off-line text-5xl md:text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-600 text-sm md:text-base">No notifications yet</p>
          </div>
        )}
      </main>

      <MobileBottomNav />
    </div>
  );
}
